// The Badging API sets a single badge for the whole installed app icon -
// there's no way to show a separate badge per feature. Anything that
// wants to contribute to it (events, song proposals, ...) registers its
// own "do I currently have something unseen" flag here instead of
// calling navigator.setAppBadge/clearAppBadge directly, so one feature
// marking itself seen doesn't wipe out another feature's still-valid
// badge.
const sources = {};

const apply = () => {
  if (!navigator.setAppBadge) return;
  const anyUnseen = Object.values(sources).some(Boolean);
  if (anyUnseen) {
    navigator.setAppBadge().catch(() => {});
  } else if (navigator.clearAppBadge) {
    navigator.clearAppBadge().catch(() => {});
  }
};

export const setBadgeSource = (name, hasUnseen) => {
  sources[name] = hasUnseen;
  apply();
};
